import * as UserAction from '@ori-events/user-action';

import { CLICK_SUBCATEGORY_LINK } from '../constants';

export const logUserClick = (url?: string) => {
  UserAction.dispatch([...CLICK_SUBCATEGORY_LINK, url ?? '']);
};
